module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_long_hazel.9ee7c6cc.png";